import { render, staticRenderFns } from "./myTeam.vue?vue&type=template&id=38898538&scoped=true&"
import script from "./myTeam.vue?vue&type=script&lang=js&"
export * from "./myTeam.vue?vue&type=script&lang=js&"
import style0 from "./myTeam.vue?vue&type=style&index=0&id=38898538&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38898538",
  null
  
)

export default component.exports